export default __webpack_public_path__ + "static/media/1.cf76223f.png";